import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout, CommonpageLayout } from "./layouts";

// Route Views
import Dashboard from "./views/Dashboard";
import UserLogin from "./views/UserLogin";
import Register from "./views/RegisterPage";
import Auth from "./views/AuthPage";
import CreateProject from "./views/CreateProject";
import CreateProjectSuperAdmin from "./views/CreateProjectSuperAdmin";
import EditProjectSuperAdmin from "./views/EditProjectSuperAdmin";
import ViewProjectsSuperAdmin from "./views/ViewProjectsSuperAdmin";
import CreateFunctionSuperAdmin from "./views/CreateFunctionSuperAdmin";
import DetailFunctionSuperAdmin from "./views/DetailFunctionSuperAdmin";
import ViewFunctionSuperAdmin from "./views/ViewFunctionSuperAdmin";
import CreateConversionsPage from "./views/CreateConversionsPage";
import DetailConversionsPage from "./views/DetailConversionsPage";
import ViewConversionsPage from "./views/ViewConversionsPage";
import CreateUser from "./views/CreateUser";
import ViewUsers from "./views/ViewUsers";
import DetailUser from "./views/DetailUser";
import ViewProject from "./views/ViewProject";
import EditProject from "./views/EditProject";
import ViewProjectStructure from "./views/ViewProjectStructure";
import ViewProjectSupplier from "./views/ViewProjectSupplier";
import ViewProjectFile from "./views/ViewProjectFile";
import ProjectStructureDetail from "./views/ProjectStructureDetail";
import ProjectSupplierDetail from "./views/ProjectSupplierDetail";
import ProjectFileDetail from "./views/ProjectFileDetail";
import CreateProjectStructure from "./views/CreateProjectStructure";
import CreateProjectSupplierConfig from "./views/CreateProjectSupplierConfig";
import CreateProjectFileConfig from "./views/CreateProjectFileConfig";
import BatchReport from "./views/BatchReport";
import RawFileUpload from "./views/RawFileUpload";
import Report from "./views/Report";
import ManageWards from "./views/ManageWards";

const AuthRoutes = [
  {
    path: "/",
    exact: true,
    layout: CommonpageLayout,
    component: () => <Redirect to="/login" />,
  },
  {
    path: "/login",
    layout: CommonpageLayout,
    component: UserLogin,
  },
  {
    path: "/register",
    layout: CommonpageLayout,
    component: Register,
  },
  {
    path: "/auth",
    layout: CommonpageLayout,
    component: Auth,
  },
  {
    path: "**",
    exact: true,
    layout: CommonpageLayout,
    component: () => <Redirect to="/login" />,
  },
];

const USER_ROLES = { superadmin: "superadmin", admin: "admin", user: "user" };

const CommonRoutes = [
  {
    path: "/dashboard",
    layout: DefaultLayout,
    component: Dashboard,
  },
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/view-projects-superadmin" />,
  },
];

const SuperadminRoutes = [
  ...CommonRoutes,
  {
    path: "/create-project-superadmin",
    layout: DefaultLayout,
    component: CreateProjectSuperAdmin,
  },
  {
    path: "/view-projects-superadmin",
    layout: DefaultLayout,
    component: ViewProjectsSuperAdmin,
  },
  {
    path: "/project-superadmin/:id/edit",
    layout: DefaultLayout,
    component: EditProjectSuperAdmin,
    exact: true,
  },
  {
    path: "/project-superadmin/:id",
    layout: DefaultLayout,
    component: ViewProject,
    exact: true,
  },
  {
    path: "/create-function-superadmin/:projectId",
    layout: DefaultLayout,
    component: CreateFunctionSuperAdmin,
  },
  {
    path: "/create-function-superadmin",
    layout: DefaultLayout,
    component: CreateFunctionSuperAdmin,
  },
  {
    path: "/view-function-superadmin",
    layout: DefaultLayout,
    component: ViewFunctionSuperAdmin,
  },
  {
    path: "/create-user",
    layout: DefaultLayout,
    component: CreateUser,
  },
  {
    path: "/edit-user/:id",
    layout: DefaultLayout,
    component: CreateUser,
  },
  {
    path: "/view-users",
    layout: DefaultLayout,
    component: ViewUsers,
  },
  {
    path: "/user-details/:id",
    layout: DefaultLayout,
    component: DetailUser,
  },
  {
    path: "/batch-report/:id",
    layout: DefaultLayout,
    component: BatchReport,
  },
  {
    path: "/report/:id/supplier/:suppliercode",
    layout: DefaultLayout,
    component: Report,
  },
  {
    path: "/report/:id",
    layout: DefaultLayout,
    component: Report,
  },
  {
    path: "/function/:id/edit",
    layout: DefaultLayout,
    component: CreateFunctionSuperAdmin,
  },
  {
    path: "/function/:id/details",
    layout: DefaultLayout,
    component: DetailFunctionSuperAdmin,
  },
  {
    path: "/conversion/:id/details",
    layout: DefaultLayout,
    component: DetailConversionsPage,
  },
  {
    path: "/conversion/:id/edit",
    layout: DefaultLayout,
    component: CreateConversionsPage,
  },
  {
    path: "/conversion/view",
    layout: DefaultLayout,
    component: ViewConversionsPage,
  },
  {
    path: "/conversion/create",
    layout: DefaultLayout,
    component: CreateConversionsPage,
  },
  {
    path: "/project/:id",
    layout: DefaultLayout,
    component: ViewProject,
    exact: true,
  },
  {
    path: "/project/:id/structure",
    layout: DefaultLayout,
    component: ViewProjectStructure,
    exact: true,
  },
  {
    path: "/project/:id/supplier",
    layout: DefaultLayout,
    component: ViewProjectSupplier,
    exact: true,
  },
  {
    path: "/project/:id/file",
    layout: DefaultLayout,
    component: ViewProjectFile,
    exact: true,
  },
  {
    path: "/project/:id/structure/create",
    layout: DefaultLayout,
    component: CreateProjectStructure,
  },
  {
    path: "/project/:id/supplier/create",
    layout: DefaultLayout,
    component: CreateProjectSupplierConfig,
  },
  {
    path: "/project/:id/file/create",
    layout: DefaultLayout,
    component: CreateProjectFileConfig,
  },
  {
    path: "/project/:id/structure/:sid/detail",
    layout: DefaultLayout,
    component: ProjectStructureDetail,
  },
  {
    path: "/project/:id/supplier/:sid/detail",
    layout: DefaultLayout,
    component: ProjectSupplierDetail,
  },
  {
    path: "/project/:id/file/:fid/detail",
    layout: DefaultLayout,
    component: ProjectFileDetail,
  },
  {
    path: "/project/:id/edit",
    layout: DefaultLayout,
    component: EditProject,
  },
  {
    path: "/project/:id/structure/:sid/edit",
    layout: DefaultLayout,
    component: CreateProjectStructure,
  },
  {
    path: "/project/:id/supplier/:sid/edit",
    layout: DefaultLayout,
    component: CreateProjectSupplierConfig,
  },
  {
    path: "/project/:id/file/:fid/edit",
    layout: DefaultLayout,
    component: CreateProjectFileConfig,
  },
  {
    path: "/project/:id/structure/:sid/:clone",
    layout: DefaultLayout,
    component: CreateProjectStructure,
  },
  {
    path: "/project/:id/file/:fid/:clone",
    layout: DefaultLayout,
    component: CreateProjectFileConfig,
  },
  {
    path: "/functions/:id",
    layout: DefaultLayout,
    component: ViewFunctionSuperAdmin,
  },
  {
    path: "/raw-file-upload/:id",
    layout: DefaultLayout,
    component: RawFileUpload,
  },
  {
    path: "/manageward/:id",
    layout: DefaultLayout,
    component: ManageWards,
  },
  {
    path: "**",
    exact: true,
    layout: CommonpageLayout,
    component: () => <Redirect to="/view-projects-superadmin" />,
  },
];

const AdminRoutes = [
  // {
  //   path: "/create-project",
  //   layout: DefaultLayout,
  //   component: CreateProject,
  // },
  {
    path: "/project/:id",
    layout: DefaultLayout,
    component: ViewProject,
    exact: true,
  },
  {
    path: "/project/:id/structure",
    layout: DefaultLayout,
    component: ViewProjectStructure,
    exact: true,
  },
  {
    path: "/project/:id/supplier",
    layout: DefaultLayout,
    component: ViewProjectSupplier,
    exact: true,
  },
  {
    path: "/project/:id/file",
    layout: DefaultLayout,
    component: ViewProjectFile,
    exact: true,
  },
  {
    path: "/project/:id/structure/create",
    layout: DefaultLayout,
    component: CreateProjectStructure,
  },
  {
    path: "/project/:id/supplier/create",
    layout: DefaultLayout,
    component: CreateProjectSupplierConfig,
  },
  {
    path: "/project/:id/file/create",
    layout: DefaultLayout,
    component: CreateProjectFileConfig,
  },
  {
    path: "/project/:id/structure/:sid/detail",
    layout: DefaultLayout,
    component: ProjectStructureDetail,
  },
  {
    path: "/project/:id/supplier/:sid/detail",
    layout: DefaultLayout,
    component: ProjectSupplierDetail,
  },
  {
    path: "/project/:id/file/:fid/detail",
    layout: DefaultLayout,
    component: ProjectFileDetail,
  },
  {
    path: "/project/:id/edit",
    layout: DefaultLayout,
    component: EditProject,
  },
  {
    path: "/project/:id/structure/:sid/edit",
    layout: DefaultLayout,
    component: CreateProjectStructure,
  },
  {
    path: "/project/:id/supplier/:sid/edit",
    layout: DefaultLayout,
    component: CreateProjectSupplierConfig,
  },
  {
    path: "/project/:id/file/:fid/edit",
    layout: DefaultLayout,
    component: CreateProjectFileConfig,
  },
  {
    path: "/project/:id/structure/:sid/:clone",
    layout: DefaultLayout,
    component: CreateProjectStructure,
  },
  {
    path: "/project/:id/file/:fid/:clone",
    layout: DefaultLayout,
    component: CreateProjectFileConfig,
  },
  {
    path: "/batch-report/:id",
    layout: DefaultLayout,
    component: BatchReport,
  },
  {
    path: "/report/:id/supplier/:suppliercode",
    layout: DefaultLayout,
    component: Report,
  },
  {
    path: "/report/:id",
    layout: DefaultLayout,
    component: Report,
  },
  {
    path: "/create-user",
    layout: DefaultLayout,
    component: CreateUser,
  },
  {
    path: "/edit-user/:id",
    layout: DefaultLayout,
    component: CreateUser,
  },
  {
    path: "/view-users",
    layout: DefaultLayout,
    component: ViewUsers,
  },
  {
    path: "/user-details/:id",
    layout: DefaultLayout,
    component: DetailUser,
  },
  {
    path: "/raw-file-upload/:id",
    layout: DefaultLayout,
    component: RawFileUpload,
  },
  {
    path: "/manageward/:id",
    layout: DefaultLayout,
    component: ManageWards,
  },
  ...CommonRoutes,
  {
    path: "**",
    exact: true,
    layout: CommonpageLayout,
    component: () => <Redirect to="/view-projects-superadmin" />,
  },
];

const UserRoutes = [
  ...CommonRoutes,
  {
    path: "/project/:id",
    layout: DefaultLayout,
    component: ViewProject,
    exact: true,
  },
  {
    path: "/project/:id/structure",
    layout: DefaultLayout,
    component: ViewProjectStructure,
    exact: true,
  },
  {
    path: "/project/:id/supplier",
    layout: DefaultLayout,
    component: ViewProjectSupplier,
    exact: true,
  },
  {
    path: "/project/:id/file",
    layout: DefaultLayout,
    component: ViewProjectFile,
    exact: true,
  },
  {
    path: "/project/:id/structure/create",
    layout: DefaultLayout,
    component: CreateProjectStructure,
  },
  {
    path: "/project/:id/supplier/create",
    layout: DefaultLayout,
    component: CreateProjectSupplierConfig,
  },
  {
    path: "/project/:id/file/create",
    layout: DefaultLayout,
    component: CreateProjectFileConfig,
  },
  {
    path: "/project/:id/structure/:sid/detail",
    layout: DefaultLayout,
    component: ProjectStructureDetail,
  },
  {
    path: "/project/:id/supplier/:sid/detail",
    layout: DefaultLayout,
    component: ProjectSupplierDetail,
  },
  {
    path: "/project/:id/file/:fid/detail",
    layout: DefaultLayout,
    component: ProjectFileDetail,
  },
  {
    path: "/project/:id/structure/:sid/edit",
    layout: DefaultLayout,
    component: CreateProjectStructure,
  },
  {
    path: "/project/:id/supplier/:sid/edit",
    layout: DefaultLayout,
    component: CreateProjectSupplierConfig,
  },
  {
    path: "/project/:id/file/:fid/edit",
    layout: DefaultLayout,
    component: CreateProjectFileConfig,
  },
  {
    path: "/project/:id/structure/:sid/:clone",
    layout: DefaultLayout,
    component: CreateProjectStructure,
  },
  {
    path: "/project/:id/file/:fid/:clone",
    layout: DefaultLayout,
    component: CreateProjectFileConfig,
  },
  {
    path: "/batch-report/:id",
    layout: DefaultLayout,
    component: BatchReport,
  },
  {
    path: "/report/:id",
    layout: DefaultLayout,
    component: Report,
  },
  {
    path: "/raw-file-upload/:id",
    layout: DefaultLayout,
    component: RawFileUpload,
  },
  {
    path: "/manageward/:id",
    layout: DefaultLayout,
    component: ManageWards,
  },
  {
    path: "**",
    exact: true,
    layout: CommonpageLayout,
    component: () => <Redirect to="/view-projects-superadmin" />,
  },
];

export { CommonRoutes as default };
export { USER_ROLES, AuthRoutes, SuperadminRoutes, AdminRoutes, UserRoutes };
